export const entityTagToCountry: Record<string, string> = {
  spy_arca: 'US',
  ewc_arca: 'CA',
  ewu_arca: 'GB',
  ewg_arca: 'DE',
  ewq_arca: 'FR',
  ewl_arca: 'CH',
  ewn_arca: 'NL',
  ewp_arca: 'ES',
  ewi_arca: 'IT',
  ewd_arca: 'SE',
  eden_bats: 'DK',
  norw_arca: 'NO',
  efnl_bats: 'FI',
  ewk_arca: 'BE',
  eirl_arca: 'IE',
  ewo_arca: 'AT',
  ewj_arca: 'JP',
  ewa_arca: 'AU',
  ewh_arca: 'HK',
  ews_arca: 'SG',
  enzl: 'NZ',
  eis_arca: 'IL',
  mchi: 'CN',
  ewt_arca: 'TW',
  ewy_arca: 'KR',
  inda_bats: 'IN',
  eido_arca: 'ID',
  thd_arca: 'TH',
  ewm_arca: 'MY',
  ephe_arca: 'PH',
  eza_arca: 'ZA',
  ksa_arca: 'SA',
  uae_nasd: 'AE',
  qat_nasd: 'QA',
  tur_nasd: 'TR',
  epol_arca: 'PL',
  grek_arca: 'GR',
  ewz_arca: 'BR',
  eww_arca: 'MX',
  ech_bats: 'CL',
  epu_arca: 'PE',
};
